/* eslint-disable */
import React, { createContext, useEffect, useState } from "react";
import updatePricingQueueStatusAPI, { fetchPricingDetailsAPI } from "../../../api/user";
import { DropDownDetails, FormValidationObject, PricingDetail } from "../../shared/handleFormData";
import {
  Grid,
  Typography,
  RACLightTooltip,
} from "@rentacenter/racstrap";
import { globalStyles } from "../Styles/globalstyles";
import moment from "moment";
export const PricingDetailsProvider = createContext<any>("");
export default function PricingContext(props: any) {
  const [disableFilter, setDisableFilter] = useState<any>(); //instead of it use searchBtnTrigger
  const filterObj = {
    rmsItemNumber: null,
    brandName: null,
    modelNumber: null,
    departmentNumber: null,
    subdepartmentNumber: null,
    zoneNumber: [],
    bracketNumber: null,
    type: "",
    category: "",
    offset: "0",
    limit: "25",
  };

  const [type, setType] = useState([
    { label: "Select", value: "" },
    { label: "MANUAL", value: "MANUAL" },
    { label: "PERMANENT", value: "PERMANENT" },
    { label: "TEMPORARY", value: "TEMPORARY" },
  ]);
  const [category, setCategory] = useState([
    { label: "Select", value: "" },
    { label: "Clearance", value: "CLEARANCE" },
    { label: "Extended Aisle", value: "EA" },
    { label: "Regular", value: "REGULAR" },
  ]);
  const [companyCode,setCompanyCode] = useState([]);
  const [isFranchiseeUser, setIsFranchiseeUser] = useState(false);
  const [loader, setLoader] = useState<any>(false);
  const [isSLACompleted, setIsSLACompleted]= useState(false);
  const [isSLACancel,setIsSLACancel] = useState(false); 
  const [filterOptions, setFilterOptions] = useState<any>(filterObj);
  const [searchBtnTrigger, setSearchBtnTrigger] = useState<any>();
  const [selectedItemsArray, setSelectedItemsArray] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [isFilterOpen, setIsFilterOpen] = useState(true); //To set the filter open close
  const [isAttachmentOpen, setIsAttachmentOpen] = useState(); // Which takes the index of the row clicked as a value
  const [isNewPricingOpen, setIsNewPricingOpen] = useState(false); // used to close/ open pricing popup add isNEw
  const [pricingQueueId, setPricingQueueId] = useState<string>();
  const [isUpdatePricingOpen, setIsUpdatePricingOpen] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [isApproved, setIsApproved] = useState(false);
  const [emailId,setEmailId]= useState();
  const [employeeId, setEmployeeId]= useState();
  const [showPopup,setShowPopup] = useState({
    removePricing: false
  })
  const [removePricingAllTypes, setRemovePricingAllTypes] = useState<number>(1);

  let addPricingRequestOject = {
    pricingType: "",
    weeklyRateNew: "",
    weeklyRateUsed: "",
    term: "",
    cashPriceFactor: "",
    forcedCashPrice: "",
    cashPrice: "",
    totalCost: "",
    manualPOTurns: "",
    startDate: "",
    endDate: "",
    cashPriceNew: "",
    totalCostNew: "",
    cashPriceUsed: "",
    totalCostUsed: "",
    queueType: "",
    clearance: "",
    sacDays:"",
    sacDaysPrinted:"",
    epoPercent:"",
    rmsItemDetails: [
      {
        zone: "",
        rmsItemNumber: [""],
      },
    ],
    weeklyRateAddOn :''
  };
  const [noRecords, setNoRecords] = useState(false);
  const [formBackupData, setFormBackupData] = useState(JSON.parse(JSON.stringify(addPricingRequestOject))); // used for textboxes in the popup backup data
  const [addPricingReq, setAddPricingReq] = useState(JSON.parse(JSON.stringify(addPricingRequestOject))); // used for textboxes in the popup actual data
  const [isRecUpdated, setIsRecUpdated] = useState(false);
  const [zoneOptions, setZoneOptions] = useState<any>([]);
  const [pricingGridData, setPricingGridData] = useState<any>();
  const pricingTable = [
    {
      heading: "",
      isSortable: "true",
      sortDirection: "DESC",
      key: "zone",
      removePricing : true, 
    },
    {
      heading: "Zone",
      isSortable: true,
      sortDirection: "DESC",
      key: "zoneNumber",
      isSorted: true,
      removePricing : true,
    },
    {
      heading: "Department",
      isSortable: true,
      sortDirection: "DESC",
      key: "departmentName",
      isSorted: true,
      removePricing : true,
    },
    {
      heading: "Sub-Department",
      isSortable: true,
      sortDirection: "DESC",
      key: "subdepartmentName",
      isSorted: true,
      removePricing : true,
    },
    {
      heading: "Bracket",
      isSortable: false,
      sortDirection: "DESC",
      key: "bracketName",
      isSorted: false,
      removePricing : true,
    },
    {
      heading: "RMS #",
      isSortable: true,
      sortDirection: "DESC",
      key: "rmsItemNumber",
      isSorted: true,
      removePricing : true,
    },
    {
      heading: "RMS Description",
      isSortable: false,
      sortDirection: "DESC",
      key: "rmsItemDescription",
      isSorted: false,
      removePricing : true,
    },
    {
      heading: "Type",
      isSortable: false,
      sortDirection: "DESC",
      key: "pricingType",
      isSorted: false,
      removePricing : true,
    },
    {
      heading: "Weekly Rate New",
      isSortable: false,
      sortDirection: "DESC",
      key: "weeklyRateNew",
      isSorted: false,
      removePricing : true,
    },
    {
      heading: "Weekly Rate Used",
      isSortable: false,
      sortDirection: "DESC",
      key: "weeklyRateUsed",
      isSorted: false,
      removePricing : true,
    },
    {
      heading: "Add-On Rate",
      isSortable: false,
      sortDirection: "DESC",
      key: "weeklyRateAddOn",
      isSorted: false,
      removePricing : true,
    },
    {
      heading: "Term",
      isSortable: false,
      sortDirection: "DESC",
      key: "term",
      isSorted: false,
      removePricing : true,
    },
    {
      heading: "Cash Price Factor",
      isSortable: false,
      sortDirection: "DESC",
      key: "cashPriceFactor",
      isSorted: false,
      removePricing : true,
    },
    {
      heading: "Forced Cash Price",
      isSortable: false,
      sortDirection: "DESC",
      key: "forcedCashPrice",
      isSorted: false,
      removePricing : true,
    },
    {
      heading: "Manual Po-Turns",
      isSortable: false,
      sortDirection: "DESC",
      key: "manualPoTurns",
      isSorted: false,
      removePricing : true,
    },
    {
      heading: "SAC Days",
      isSortable: false,
      sortDirection: "DESC",
      key: "sacDays",
      isSorted: false,
      removePricing : true,
    },
    {
      heading: "SAC Days Printed",
      isSortable: false,
      sortDirection: "DESC",
      key: "sacDaysPrinted",
      isSorted: false,
      removePricing : true,
    },
    {
      heading: "EPO Percentage",
      isSortable: false,
      sortDirection: "DESC",
      key: "epoPercent",
      isSorted: false,
      removePricing : true,
    },
    {
      heading: "Brand",
      isSortable: false,
      sortDirection: "DESC",
      key: "brandName",
      isSorted: false,
    },
    {
      heading: "Model #",
      isSortable: false,
      sortDirection: "DESC",
      key: "modelNumber",
      isSorted: false,
    },
    {
      heading: "Purchase Cost",
      isSortable: false,
      sortDirection: "DESC",
      key: "purchaseCost",
      isSorted: false,
    },
    {
      heading: "Cash Price (NEW)",
      isSortable: false,
      sortDirection: "DESC",
      key: "cashPriceNew",
      isSorted: false,
    },
    {
      heading: "Cash Price Turns (NEW)",
      isSortable: false,
      sortDirection: "DESC",
      key: "cashPriceTurn",
      isSorted: false,
    },
    {
      heading: "Total Cost (NEW)",
      isSortable: false,
      sortDirection: "DESC",
      key: "totalCostNew",
      isSorted: false,
    },
    {
      heading: "TRTO Turns (NEW)",
      isSortable: false,
      sortDirection: "DESC",
      key: "totalRtoTurn",
      isSorted: false,
    },
    {
      heading: "Cash Price (USED)",
      isSortable: false,
      sortDirection: "DESC",
      key: "cashPriceUsed",
      isSorted: false,
    },
    {
      heading: "Total Cost (USED)",
      isSortable: false,
      sortDirection: "DESC",
      key: "totalCostUsed",
      isSorted: false,
    },
    {
      heading: "Start Date",
      isSortable: true,
      sortDirection: "DESC",
      key: "startDate",
      isSorted: true,
      removePricing : true, 
    },
    {
      heading: "End Date",
      isSortable: true,
      sortDirection: "DESC",
      key: "endDate",
      isSorted: true,
      removePricing : true, 
    },
    {
      heading: "Attachment",
      isSortable: false,
      sortDirection: "DESC",
      key: "attachment",
      isSorted: false,
    },
  ];
  const classes = globalStyles();
  const [someThingWentWrng, setSomeThingWentWrng] = useState(false);
  const [rmsItemDetailsArr, setRmsItemDetailsArr] = useState([]);
  const [pricingHeader, setPricingHeader] = useState(pricingTable);
  const [currentTableData, setCurrentTableData] = useState([]);
  const [isApprover, setIsApprover]= useState(false);
  const [isApprovalOpen, setIsApprovalOpen] = useState(false);

  const[authOpen, setAuthOpen] = useState(false);
  const [fullloader,setFullloader] = useState(false);
  const [approvedBy,setApprovedBy] = useState();
  const [bracketOptionsOrg, setbracketOptionsOrg] = useState<DropDownDetails[]>([{
    label: "Select",
    value: "",
    subdepartmentnumber: ''
  }]);
  const [subDeptOptionsOrg, setsubDeptOptionsOrg] = useState<any>([{
    label: "Select",
    value: "",
    departmentnumber: ''
  }]);
  const [deptOptions, setDeptOptions] = useState<any>([{
    label: "Select",
    value: "",
  }]);
 
  const [ formValidationObject, setFormValidationObject ] = useState<FormValidationObject>({
    isOpen: false,
    isError:false,
    message:''
  })

  const fetchpricingGridData = async (type: any = "", index: any = 0) => {
    let arr = pricingGridData ? Object?.keys(pricingGridData) : undefined;
    setLoader(true);
    let pricingRequest = JSON.parse(JSON.stringify(filterOptions));
    pricingRequest.offset = `${index + 1}`;
    pricingRequest.category =
      pricingRequest.category === "" ? undefined : pricingRequest.category;
    pricingRequest.type =
      pricingRequest.type === "" ? undefined : pricingRequest.type;
      pricingRequest.zoneNumber =  pricingRequest.zoneNumber.length == zoneOptions.length ? undefined:  pricingRequest.zoneNumber;
      pricingRequest.companyCode = companyCode.length ? companyCode : undefined;
    try {
      let arr1=Object.keys(pricingRequest)
      arr1.forEach((item : any)=>{if(!pricingRequest[item] && item !='type' && item !='category'&& item !='zoneNumber' )pricingRequest[item]=null})
      if (arr?.length && type !== "A") {
        if (arr?.includes(`${index}`)) {
          setCurrentTableData(pricingGridData[index]);
        } else {
          setTotalRowCount(0);
          const resp = await fetchPricingDetailsAPI(pricingRequest);
          handleApiResponse(resp, index,type);
        }
      } else {
        setTotalRowCount(0);
        const resp = await fetchPricingDetailsAPI(pricingRequest);
        handleApiResponse(resp, index, type);
        setPageCount(Math.ceil(resp.data.totalRecordsCount / 25));
      }
    } catch (err) {
      setSomeThingWentWrng(true);
    } finally {
      setLoader(false);
    }
  };
  const handleApiResponse = (resp: any, index: any, type : string) => {
    if (resp.status === 200) {
      if (resp.data?.pricingDetails?.length) {
        setIsFilterOpen(false);
        setTotalRowCount(resp.data.totalRecordsCount);
        setCurrentTableData(resp.data.pricingDetails);
        if(type !='A'){
        setPricingGridData({
          ...pricingGridData,
          [`${index}`]: resp.data.pricingDetails,
        });
      }
      } else {
        setNoRecords(true);
      }
    } else {
      throw "Err";
    }
  };
  const updatePricingQueueStatus = async (params: any) => {
    try {
      setFullloader(true);
      let req = {
        pricingQueueId: pricingQueueId?.toString(),
        status: params,
        actionBy: approvedBy,
      };
      const response = await updatePricingQueueStatusAPI(req);
      if (response.status == 200) {
        setFullloader(false);
        setSelectedItemsArray([]);
        setAuthOpen(false);
        setIsApproved(true);
        // await fetchpricingGridData('A');
      } else {
        setSomeThingWentWrng(true);
        setFullloader(false);
      }
    } catch (e) {
      setSomeThingWentWrng(true);
      setFullloader(false);
    }
  };
  const integrateWithToolTip = (obj : PricingDetail,iterator: keyof PricingDetail, isDate: boolean = false,isString : boolean = false)=>{
    return (
      <RACLightTooltip
      style={{backgroundColor:'white'}}
      placement={'top-start'}
      text={<>
                    <Grid container  className={`${classes.tooltipCustomStyles}`}>
                      <Grid item md ={12}>
                      <Typography display ={'inline'}>Department: </Typography>
                      <Typography display ={'inline'}>{obj.departmentName? obj.departmentName : '-'}</Typography>
                      </Grid>
                      <Grid item md ={12}>
                      <Typography display ={'inline'}>Sub Department: </Typography>
                      <Typography display ={'inline'}>{obj.subdepartmentName? obj.subdepartmentName :'-'}</Typography>
                      </Grid>
                      <Grid item md ={12}>
                      <Typography display ={'inline'}> Bracket: </Typography>
                      <Typography display ={'inline'}>{obj.bracketName? obj.bracketName :"-"}</Typography>
                      </Grid>
                      <Grid item md ={12}>
                      <Typography display ={'inline'}>RMS #: </Typography>
                      <Typography display ={'inline'}>{obj.rmsItemNumber?obj.rmsItemNumber : '-'}</Typography>
                      </Grid>
                      </Grid>
                    </>
                  }
                >
                  <Grid zeroMinWidth style={{display:'inline'}}>
                  {isDate ?  moment(obj[iterator]).format("MM/DD/YYYY") : isString ? obj[iterator] ? obj[iterator] : "-": obj[iterator] && (!isNaN(Number(obj[iterator])))? `$${Number(obj[iterator]).toFixed(2)}` : "-"}
                  </Grid>
      </RACLightTooltip>
    )
  }
  return (
    <PricingDetailsProvider.Provider
      value={{
        pricingHeader,
        someThingWentWrng,
        setSomeThingWentWrng,
        setPricingHeader,
        fetchpricingGridData,
        currentTableData,
        setCurrentTableData,
        disableFilter,
        addPricingRequestOject,authOpen, setAuthOpen,
        isSLACancel,setIsSLACancel,approvedBy,setApprovedBy,
        addPricingReq,showPopup,setShowPopup,
        removePricingAllTypes, setRemovePricingAllTypes,
        setAddPricingReq,
        setDisableFilter,integrateWithToolTip,
        formBackupData,
        setFormBackupData,
        rmsItemDetailsArr,
        setRmsItemDetailsArr,
        isAttachmentOpen,
        isRecUpdated,
        setIsRecUpdated,
        setIsAttachmentOpen,updatePricingQueueStatus,
        pricingGridData,bracketOptionsOrg, 
        setbracketOptionsOrg,subDeptOptionsOrg, 
        setsubDeptOptionsOrg,
        deptOptions, setDeptOptions, 
        formValidationObject, setFormValidationObject,
        setNoRecords,
        noRecords,companyCode,setCompanyCode,
        setPricingGridData,
        filterOptions,
        setFilterOptions,
        filterObj,
        isFilterOpen,
        setIsFilterOpen,
        searchBtnTrigger,
        setSearchBtnTrigger,
        type,
        setType,
        category,
        setCategory,
        loader,
        setLoader,
        isNewPricingOpen,
        pageCount,
        setPageCount,
        setIsNewPricingOpen,
        pricingTable,
        totalRowCount,
        setTotalRowCount,
        selectedItemsArray,setIsApprover,
        setSelectedItemsArray,
        pageNumber,
        setPageNumber,
        pricingQueueId,
        setPricingQueueId,
        zoneOptions,isApproved, setIsApproved,
        setZoneOptions,isApprovalOpen, setIsApprovalOpen,
        isUpdatePricingOpen,fullloader,setFullloader,isFranchiseeUser, setIsFranchiseeUser,
        setIsUpdatePricingOpen,employeeId, setEmployeeId,emailId,setEmailId,
        isApprover,isSLACompleted, setIsSLACompleted,
      }}
    >
      {props.children}
    </PricingDetailsProvider.Provider>
  );
}
